









































































































































































import ProgramBulkCopyDialog from '@/components/program-bulk-copy-dialog.vue'
import ProgramBulkDeleteDialog from '@/components/program-bulk-delete-dialog.vue'
import ProgramBulkUpdateStreams from '@/components/program-bulk-update-streams.vue'
import ProgramBulkUpdateToken from '@/components/program-bulk-update-token.vue'
import ProgramBulkUpdateBackend from '@/components/program-bulk-update-backend.vue'
import { ProgramRepository } from '@/core/api/programs'
import { REQUEST_ERROR, REQUEST_SUCCESS } from '@/core/events/requests'
import { tableSortHandler } from '@/core/table-sort-handler'
import _ from 'lodash'
import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'

export default Vue.extend({
  components: {
    ProgramBulkUpdateStreams,
    ProgramBulkUpdateToken,
    ProgramBulkUpdateBackend,
    ProgramBulkCopyDialog,
    ProgramBulkDeleteDialog,
  },
  data: () => ({
    loading: false,
    selected: [],
    items: [],
    itemsCount: null,
    page: 1,
    pageCount: 1,
    sortHandler: tableSortHandler('name'),
    headers: [
      {
        text: 'Источник',
        value: 'source.name',
      },
      {
        text: 'Название',
        value: 'name',
      },
      {
        text: 'Изменен',
        value: 'modified',
      },
      {
        text: 'Длит',
        value: 'duration',
      },
      {
        text: 'Включить',
        value: 'enabled',
        sortable: false,
      },
      {
        text: 'Видео',
        value: 'capture_video',
        sortable: true,
      },
      {
        text: 'Запуск',
        value: 'starts_at',
        sortable: true,
      },
      {
        text: 'Потоки',
        value: 'streams_humanize',
        sortable: false,
      },
      {
        text: 'Токен',
        value: 'yandex_token__name',
        sortable: false,
      },
      {
        text: 'Платформа',
        value: 'backend',
        sortable: false,
      },
    ],
    ctxMenu: {
      visible: false,
      x: 0,
      y: 0,
    },
    bulkUpdateStreamsDialog: false,
    bulkUpdateTokenDialog: false,
    bulkUpdateBackendDialog: false,
    bulkCopyDialog: false,
    bulkDeleteDialog: false,
  }),
  computed: mapState({
    filter: (state: any) => state.programs.filter,
  }),
  mounted() {
    this.onSortChange()
  },
  methods: {
    fetch() {
      this.loading = true
      new ProgramRepository()
        .$getPage(this.page, { ...this.filter, 'page_size': 100 })
        .then(({ results, count, pages }) => {
          this.items = results
          this.itemsCount = count
          this.pageCount = pages
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearSelection() {
      this.selected = []
    },
    onItemClick(item) {
      this.$router.push({ name: 'ProgramEdit', params: { id: item.id } })
    },
    onCreateItemClick() {
      this.$router.push({ name: 'ProgramCreate' })
    },
    onPageChange() {
      this.clearSelection()
      this.fetch()
    },
    onSortChange() {
      this.clearSelection()
      this.setFilter({ ...this.filter, ordering: this.sortHandler.getApiColumn() + ',id' })
      this.fetch()
    },
    onBulkUpdateStreamsClick() {
      this.bulkUpdateStreamsDialog = true
    },
    onBulkUpdateTokenClick() {
      this.bulkUpdateTokenDialog = true
    },
    onBulkUpdateBackendClick() {
      this.bulkUpdateBackendDialog = true
    },
    onBulkCopyClick() {
      this.bulkCopyDialog = true
    },
    onBulkDeleteClick() {
      this.bulkDeleteDialog = true
    },
    onBulkToggleClick(enabled: boolean) {
      const ids = this.selected.map(x => x['id'])
      new ProgramRepository()
        .bulkUpdate(ids, { enabled })
        .then(() => {
          this.clearSelection()
          this.fetch()
          this.$event.$emit(REQUEST_SUCCESS)
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
    },
    onBulkToggleVideoClick(captureVideo: boolean) {
      const ids = this.selected.map(x => x['id'])
      new ProgramRepository()
        .bulkUpdate(ids, { captureVideo })
        .then(() => {
          this.clearSelection()
          this.fetch()
          this.$event.$emit(REQUEST_SUCCESS)
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
    },
    onBulkUpdateSubmit(update: any) {
      const ids = this.selected.map(x => x['id'])
      new ProgramRepository()
        .bulkUpdate(ids, update)
        .then(() => {
          this.clearSelection()
          this.fetch()
          this.$event.$emit(REQUEST_SUCCESS)
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
    },
    onBulkCopySubmit(update: any) {
      const ids = this.selected.map(x => x['id'])
      new ProgramRepository()
        .bulkCopy(ids, update)
        .then(() => {
          this.clearSelection()
          this.fetch()
          this.$event.$emit(REQUEST_SUCCESS)
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
    },
    onBulkDeleteSubmit(items: any) {
      const ids = items.map(x => x['id'])
      new ProgramRepository()
        .bulkDelete(ids)
        .then(() => {
          this.clearSelection()
          this.fetch()
          this.$event.$emit(REQUEST_SUCCESS)
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
    },
    onSourceNameChange: _.debounce(function(this: any, value: any) {
      this.clearSelection()
      this.setFilter({ ...this.filter, 'source_name': value })
      this.fetch()
    }, 250),
    onProgramNameChange: _.debounce(function(this: any, value: any) {
      this.clearSelection()
      this.setFilter({ ...this.filter, 'program_name': value })
      this.fetch()
    }, 250),
    onEnabledChange(value) {
      this.clearSelection()
      this.setFilter({ ...this.filter, 'enabled': value })
      this.fetch()
    },
    onVideoCaptureChange(value) {
      this.clearSelection()
      this.setFilter({ ...this.filter, 'capture_video': value })
      this.fetch()
    },
    ...mapMutations({
      setFilter: 'programs/SET_FILTER',
    }),
    onContextMenu(mouseEvent: MouseEvent) {
      mouseEvent.preventDefault()

      this.ctxMenu.x = mouseEvent.x
      this.ctxMenu.y = mouseEvent.y
      this.ctxMenu.visible = true
    },
  },
})
